export enum PaymentClient {
  Stripe = 'stripe',
  PayU = 'payu',
  Metamask = 'metamask',
  Tpay = 'tpay',
}
